class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#1A1919" d="M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z"></path></svg>';
  }
}
const s = "pwc-icon-plus";
customElements.get(s) || customElements.define(s, e);
